import {
  EMPTY_FIELD_MESSAGE,
  validateSpaceTextInput,
  validateTextEn,
} from '@Utils/validation';
import { z } from 'zod';
export enum ERROR_MESSAGE_UPLOAD_ASSETS {
  NO_FILE_PROVIDED = 'NO_FILE_PROVIDED',
  FILE_SIZE_EXCEEDED = 'FILE_SIZE_EXCEEDED',
  FILE_TYPE_NOT_ACCEPTED = 'FILE_TYPE_NOT_ACCEPTED',
  INVALID_LANGUAGE_PARAMETER = 'INVALID_LANGUAGE_PARAMETER',
  FILE_UPLOAD_ERROR = 'FILE_UPLOAD_ERROR',
  FILE_DOWNLOAD_ERROR = 'FILE_DOWNLOAD_ERROR',
  FILE_NOT_FOUND = 'FILE_NOT_FOUND',
  FILE_DELETE_ERROR = 'FILE_DELETE_ERROR',
  FILE_NAME_TOO_LONG = 'FILE_NAME_TOO_LONG',
}

export const uploadImageSchema = (messages: {
  assets: string;
  descriptionAssetsEn: string;
}) => {
  return z.object({
    fileNameTh: z.string({ message: messages.assets }),
    fileNameEn: z.string({ message: messages.assets }),
    descriptionTh: z
      .string()
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
    descriptionEn: z
      .string()
      .regex(validateTextEn, { message: messages.descriptionAssetsEn })
      .refine(validateSpaceTextInput, EMPTY_FIELD_MESSAGE.SPACE_BAR)
      .nullable()
      .optional(),
  });
};
